import Immutable from 'immutable';

import { USER_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/User';

import { initializeRegistrations } from '../actions/Registrations';

const registrationsMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  switch (action.type) {
    case USER_GET_LOADED: {
      const uid = action.user_id;
      const registrationsStartDate = action.data.field_registrations_start_date;
      const programStartDate = action.data.field_program_start_date;

      // Check if program start date exists, because we don't use it on all domains.
      if (uid && programStartDate) {
        const previousProgramStartDate = getState().getIn(['user', uid, 'field_program_start_date'], Immutable.List()).toJS();

        // If the previous state is empty, it means the state is set for the first time.
        // In that case, initialize the registrations.
        if (previousProgramStartDate.length === 0) {
          dispatch(initializeRegistrations(
            registrationsStartDate[0].value,
            programStartDate[0].value,
          ));

          return next(action);
        }

        // If the previous state is not empty, check if the program start date
        // is newer than  the previous program start date. In that case it means
        // the user has reset their program, thus we need to initialize the
        // registrations again.
        const programStartDateTime = new Date(programStartDate[0].value).getTime();
        const previousProgramStartDateTime = new Date(previousProgramStartDate[0].value).getTime();

        if (programStartDateTime > previousProgramStartDateTime) {
          dispatch(initializeRegistrations(
            registrationsStartDate[0].value,
            programStartDate[0].value,
          ));
        }
      }

      break;
    }
  }

  return next(action);
};

export default registrationsMiddleware;
